/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useState} from 'react';
import { APIEndpoint } from "../../../utils/axios";
import { DataGrid, EditModal,UploadModal } from "../../../common";
import { useTranslation } from 'react-i18next';
import Edit2 from "../../../assets/edit2.svg";
import { MIMETypes ,upliftTypesSelect} from '../../../utils/configs';
import { onDownloadXlsFile, getCultureFromLs} from '../../../utils/commonFunctions';
import usePermissions from '../../../utils/userPermissions';
const Columns = [
  { field: 'warehouseName', headerName: 'Name', resizable:true, suppressSizeToFit:true,flex:1,minWidth: 185,maxWidth:320},
  { field: 'warehouseCode', headerName: 'Code', resizable:true,tooltipField:'warehouseCode',suppressSizeToFit:true,flex:1, minWidth: 125,maxWidth:320 },
  { field: 'baseStation', headerName: 'Base Station',resizable:true,  suppressSizeToFit:true,flex:1,minWidth: 145,maxWidth:220 },
  { field: 'gstIn', headerName: 'GST IN',cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  }, resizable:true,tooltipField:'gstin', suppressSizeToFit:true,flex:1,minWidth: 185},
  { field: 'fssai', headerName: 'FSSAI No',  resizable:true,tooltipField:'fssai',suppressSizeToFit:true,flex:1,minWidth: 165},
  { field: 'sapCode', headerName: 'SAP Code', resizable:true,tooltipField:'sapCode', suppressSizeToFit:true,flex:1,minWidth: 165},
  { field: 'salesOfficeNumber', headerName: 'Sales Office No',resizable:true,tooltipField:'salesOfficeNumber',  suppressSizeToFit:true,flex:1,minWidth: 185 },
  { field: 'location', headerName: 'Location',cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  }, resizable:true,suppressSizeToFit:true,flex:1, minWidth: 200 },
];

const FormFields = [
  { label: 'Warehouse Name', attribute: 'warehouseName', type: 'text', required: true, },
  { label: 'Warehouse Code ', attribute: 'warehouseCode', type: 'text', required: true },
  { label: 'Base Station', attribute: 'clusterId', type: 'select', required: true },
  { label: 'GST IN', attribute: 'gstIn', type: 'text', required: true },
  { label: 'State', attribute: 'stateCode', type: 'select', required: true, },
  {label: 'Supported Uplift Type', attribute: 'supportedUpliftTypes', type: 'select', disabled: false, options: [], required: true },
  {label: 'Item Classifier', attribute: 'itemClassifier', type: 'select', disabled: false, options: [], required: true },
  { label: 'FSSAI License Number', attribute: 'fssai', type: 'text' },
  { label: 'SAP Code', attribute: 'sapCode', type: 'text'},
  { label: 'Sales Office Number', attribute: 'salesOfficeNumber', type: 'text' },
  { label: 'Batch Number', attribute: 'batchNumber', type: 'text' },
 { label: 'Address', attribute: 'warehouseAddress', type: 'textarea', rows: 3 },
  { label: 'Address Line 2', attribute: 'warehouseAddressLine2', type: 'textarea', rows: 3 },

]

// const States = [
//   { value: 'KA', label: 'Karnataka' }
// ]

export const WarehousePage = (props) => {
  const Fields = useRef([]);
  const clusterOptions = useRef(null);
  const { t,ready } = useTranslation();
  const [showUpload, setShowUpload] = useState(false);
  const [ uploadedFile, setUploadedFile ] = useState([])

  const [ uploadFileStatusBlock, setUploadFileStatusBlock ] = useState('');
  const [state, setState] = useState({ isListReady: false, filterBase: '', resetDataSource: false, })
  const [modalFormStatusObj, setModalFormStatusObj] = useState({ text: '' });

  const { hasPermission: editWarehouses } = usePermissions('edit', "configuration.fsc.warehouses");
  const { hasPermission: createWarehouses } = usePermissions('create', "configuration.fsc.warehouses");

  React.useEffect(() => {
    fetchDefinedList(true);
  }, []);


  const filterData = {
    action: 4,
    collection: '',
    filterOperation: 'or',
    filters: [],
    limit: 50,
    page: 1,
    searchParam: ''
  };
  const fetchWarehouse = async (iPageNo = 1, iPageLimit = 50, iSearchText = '') => {
    filterData.page = iPageNo;
    filterData.limit = iPageLimit;
    filterData.searchParam = iSearchText;
    let res = await APIEndpoint.post('warehouses/process', filterData);
    if (res.items) {
      res.items = res.items.map((_) => {
        let baseStation = clusterOptions.current.find((bs) => {
          return Number(_.clusterId) === Number(bs.value)
        });
        return {
          ..._,
          location: `${_.stateName}, (${_.country})`,
          baseStation: baseStation ? baseStation.label : ''
        }
      })
    }
    return res;
  }

  const fetchDefinedList = async (iSetState) => {
    try {
       const [clusters,itemClassifiers,supportedUpftType] = await Promise.allSettled([APIEndpoint.get('clusters'),APIEndpoint.get('itemClassifiers'),APIEndpoint.get('upliftTypes')]);
      const countryDetails = getCultureFromLs()
    if ((clusters && clusters.status==="fulfilled") && (itemClassifiers && itemClassifiers.status==="fulfilled")  && ((supportedUpftType.status==='fulfilled' && supportedUpftType.value?.success && supportedUpftType?.result?.length>0) || upliftTypesSelect.result?.length>0 )) {
      clusterOptions.current = (clusters.value.result || []).map((_c) => {
        return { value: _c.id, label: _c.value }
      })
      Fields.current = FormFields.map((_) => {
        let options;
        if (_.attribute === 'clusterId') {
          options = [{ label: t('pages.pagesContent.sectors.baseStationSelectPlaceholder'), value: '' }, ...clusterOptions.current];

        } else if (_.attribute === 'stateCode' && countryDetails.states) {
          if( countryDetails.states){
            options = [{ label: t('selectState'), value: '' }, ...countryDetails.states.map(st=>({ label:st.name, value:st.code }))];
          }
          else{
            options = [{ label: t('selectState'), value: '' }, ...countryDetails.states.map(st=>({ label:st.name, value:st.code }))];
          }
        }
        else if (_.attribute === 'itemClassifier' && itemClassifiers.value.result.length>0) {
          options = [{key: 0, label:t(t('selectButtons.selItemClassifier')), value: ''}, ...itemClassifiers.value?.result.map((st,index)=>({key: index+1, label: st.displayName, value: st.name}))];
        }
         else if (_.attribute === 'supportedUpliftTypes') {
          options = [{ key: 0, label: t(t('selectButtons.selUpliftTypes')), value: '' },...(supportedUpftType?.value?.result || upliftTypesSelect?.result)?.map((st, index) => ({key: index + 1,label: st.displayName,value: st.name}))];
        }

        return {
          ..._,
          options: options
        }
      })
    }

    } catch (error) {

    }
    if (iSetState &&  Fields.current.length) {
      setState((_) => {
        return { ..._, isListReady: true }
      })
      return true;
    }
  };
  const handleModalClose = () => {
    setState((currentState) => {
      return { ...currentState, showAddForm: false, editRow: null }
    })
  }
  const onUploadClose = () => {
    setShowUpload(false);
    setUploadedFile([]);
    setUploadFileStatusBlock('');
  }

  const onDownloadSampleFile = () => {
    onDownloadXlsFile('samples/downloads/Airports_Upload_Sample','Airports_Upload_Sample')
  }

  const onUploadFileChangeHandler = async (e) => {

};

  const handleAddWarehouse = () => {
    setModalFormStatusObj({text:""})
    setState((_) => {
      return { ..._, showAddForm:createWarehouses? true:false }
    })
  }
  const handleReset = () => {
    let timerId = setTimeout(() => {
      clearTimeout(timerId);
      setState((_) => {
        return { ..._, resetDataSource: !_.resetDataSource,showAddForm: false, editRow: null };
      })
    }, 500)
  }

  const handleWarehouseFormSubmit = async (e, values) => {
      setModalFormStatusObj({text:""})
    let isValid = true,
      isEdit = Boolean(state.editRow);
    if (values != null) {
      isValid = Fields.current.every((field) => {
        if (
          field.required &&
          ((isEdit &&
            !(values[field.attribute] || state.editRow[field.attribute])) ||
            (!isEdit && !values[field.attribute]))
        ) {
          setModalFormStatusObj({ error: `Missing ${field.label}`, });
          return false;
        }
        return true;
      });
      if (isValid) {
        try {
          let res;
          if (values.clusterId) values.clusterId = Number(values.clusterId);
          if (isEdit) {
          values = {
            ...state.editRow,
            ...(values.supportedUpliftTypes && typeof values.supportedUpliftTypes === 'string' && values.supportedUpliftTypes.length 
              ? {  ...values,supportedUpliftTypes: values.supportedUpliftTypes.split(" ")} 
              : { ...values,supportedUpliftTypes: state.editRow.supportedUpliftTypes.split(" ")})
          };
            res = await APIEndpoint.post(
              "warehouses/update/" + state.editRow.warehouseId,
              values,
            );
          } else {
            const data = values.supportedUpliftTypes && typeof values.supportedUpliftTypes === 'string' && values.supportedUpliftTypes.length 
  ? { ...values, supportedUpliftTypes: values.supportedUpliftTypes.split(" ") }
  : { ...values };
            res = await APIEndpoint.post("warehouses/new",data);
          }
          if (res && res.success) {
            setModalFormStatusObj({ text: res?.msg ||"Success" });
            setTimeout(()=>{
              handleReset(e, true)
            },1500)
          }
        } catch (error) {
         let { data } = JSON.parse(error.message);
          setModalFormStatusObj({ error: data?.msg || 'Something went wrong. Please try again after some time.'});
        }
      }
    }
    else if(!values && isEdit){
      isValid = Fields.current.every((field) => {
        if (field.required && !state.editRow[field.attribute]) {
          setModalFormStatusObj({ error: `Missing ${field.label}`, });
          return false;
        }
        return true;
      });
      if(isValid){
        try {
            const res = await APIEndpoint.post("warehouses/update/" + state.editRow.warehouseId,{...state.editRow,supportedUpliftTypes:state.editRow.supportedUpliftTypes.split(" ")});
        
          if (res && res.success) {
            setModalFormStatusObj({ text:  res?.msg ||"Success" });
            setTimeout(()=>{
              handleReset(e, true)
            },1500)
          }
        } catch (error) {
            let { data } = JSON.parse(error.message);
          setModalFormStatusObj({ error: data?.msg || 'Something went wrong. Please try again after some time.'});
        }
      }
    }

    else if(!values && state.showAddForm){
      setModalFormStatusObj({
        error: "Please fill all mandatory field!",
      });
    }
  };

  const handleRowAction = async (e, action, row) => {
    try {
       setModalFormStatusObj({text:""})
    let editRow = null;
    const warehouse = await APIEndpoint.get('warehouses/' + row.itemId);
   const resFormReady= await fetchDefinedList(true);
    if (warehouse.success && resFormReady) {
      editRow ={...warehouse.result,supportedUpliftTypes:warehouse.result.supportedUpliftTypes[0]??""};
      setState((currentState) => {
        return { ...currentState, editRow: editRow }
      })
    } else {
     
    }
    } catch (error) {
      
    }
   
  }


  return (
    <div className="op-aircraft-container flexCol full-flex ag-theme-alpine-dark">

      {
        Boolean(state.isListReady) &&
        <>
          <DataGrid
            columnResize
            resetDataSource={state.resetDataSource}
            showDefaultFilters
            className='full-flex'
            columns={Columns}
            pageType={false}
            getRows={fetchWarehouse}
            addButton={{
              title: t('pages.pagesContent.warehouse.addButtonTitle'),
              onClick: handleAddWarehouse
            }}
            actions={[
              { detail:editWarehouses? [{ src: Edit2,title:'Edit', value: "edit" }]:[] }
            ]}
            onAction={handleRowAction}
          />
          {
          state && Boolean(state.showAddForm || state.editRow) && Fields.current?.length &&
            <EditModal
              title={
                Boolean(state.editRow) ? t('pages.pagesContent.warehouse.editModalTitle') :
                  t('pages.pagesContent.warehouse.addModalTitle')
              }
              onClose={handleModalClose}
              showFieldsInColumn={true}
              onSubmit={handleWarehouseFormSubmit}
              buttonLabel={t('buttons.save')}
              modalFormStatusObj={modalFormStatusObj}
              fields={
                (Fields.current || []).map((_) => {
                  const isEdit = Boolean(state.editRow);
                  return { ..._, initialValue: isEdit ? state.editRow[_.attribute] : '' }
                })
              }
            />
          }
       {
        showUpload &&
        <UploadModal
          modelTitle={t('pages.pagesContent.warehouse.uploadButton')}
          onUploadClose={onUploadClose}
          onDownloadSampleFile={onDownloadSampleFile}
          uploadedFile = { uploadedFile }
          onUploadFileChangeHandler = { (e) => onUploadFileChangeHandler(e) }
          uploadFileStatusBlock = { uploadFileStatusBlock }
          allowedExtensions={ MIMETypes.excel }
        />
      }
        </>
      }
       {
                  !ready &&<div className='overlay_hide sub'></div>
                }

    </div>
  )
}